<template>
    <div class="material-view">
        <header class="material-view__header">
            <div class="material-view__breadcrumbs">
                <button @click="handleCloseMaterial" type="button" class="material-view__close-view">
                    <img class="material-view__arrow" src="@/assets/images/icons/right-arrow.svg"/>
                    Powrót do materiałów online
                </button>
            </div>
        </header>
        <div class="material-view__iframe-container">
            <Loader v-show="!iframe.loaded || isLoading" />
            <transition name="fade" appear>
                <iframe ref="frame" @load="handleOnLoad" v-show="iframe.loaded && !isLoading" class="material-view__iframe" :src="src" allowfullscreen allow="camera; microphone"></iframe>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      iframe: {
        loaded: false,
      },
      srcWithCurrentDate: '',
    };
  },
  props: {
    src: String,
    isLoading: Boolean,
  },
  methods: {
    ...mapMutations('auth', ['setLogoutBlocked']),

    handleCloseMaterial() {
      this.$emit('close-material');
    },
    handleOnLoad() {
      this.iframe.loaded = true;
      this.setLogoutBlocked(false);
    },
  },
  mounted() {
    this.srcWithCurrentDate = `${this.src}?timestamp=${new Date().getTime()}`;
  },
};
</script>

<style scoped lang="scss">
.material-view {
    height: 100vh;
    width: 100%;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
    @media screen and (min-width: 992px) {
        width: calc(100% - 312px);
    }
    &__header{
        @apply bg-blue-light-main;
        width: 100%;
        padding: 100px 1.5rem 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media screen and (min-width: 864px) {
            padding: 100px 64px 25px;
        }
        @media screen and (min-width: 992px) {
            padding: 58px 24px 25px;
        }
        @media screen and (min-width: 1147px) {
            padding: 58px 64px 25px;
        }
    }
    &__breadcrumbs{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
    }
    &__bredcrumb-link{
        position: relative;
        color: #ff5a44;
        font-size: 14px;
        display: none;
        @media screen and (min-width: 500px) {
            display: block;
        }
        &:before{
            content: "❮";
            font-size: 10px;
            margin-right: 10px;
            color: #ff5a44;
        }
    }
    &__iframe-container{
        @apply bg-blue-light-main;
        display: flex;
        align-items: stretch;
        flex-grow: 1;
        height: calc(100vh - 67px - 133px);
        @media screen and (min-width: 992px) {
            height: calc(100vh - 101px);
        }
    }
    &__iframe{
        @apply bg-blue-light-main;
        width: 100%;
        height: calc(100vh - 67px - 133px);
        @media screen and (min-width: 992px) {
            height: calc(100vh - 101px);
        }
    }
    &__close-view{
        display: flex;
        justify-content: center;
        align-items: center;
        -webkit-text-stroke-width: 0;
    }
    &__arrow{
        width: 20px;
        margin-right: 10px;
        display: block;
    }
}
</style>
